import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ApiResponse } from '../../../types';
import { useDefaultUserStore } from '../../../store';
import { API_IDENTITY } from '../../../api/api.base';
import { slowRequestConfig } from '../../../api/slowRequestConfig';
import { Alerter } from '../../../utils';
import { QueryKeys } from '../../../constants';
import { OnboardingForm } from '../../../pages/Messenger/validation';

export const useCustomCampaignMutation = () => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { user } = useDefaultUserStore();

	return useMutation<ApiResponse<string>, unknown, OnboardingForm>({
		mutationFn: payload =>
			API_IDENTITY.post(
				'/api/user/active-campaign/custom-fields',
				payload,
				// Sequential ActiveCampaign calls on the server.
				slowRequestConfig,
			),
		onSuccess(data) {
			if (data.success) {
				queryClient.invalidateQueries({
					queryKey: [QueryKeys.CURRENT_USER_ERROR_HANDLING],
				});
				if (user) {
					navigate('/quick-start');
				}
			} else {
				Alerter.error(data?.errors?.[0].message || 'Error');
			}
		},
		onError(error) {
			Alerter.error(error instanceof Error ? error.message : 'Error');
		},
	});
};
